import { useEffect } from 'react'
import { List, ListItemAvatar, ListItemButton, ListItemText, SxProps, Typography } from '@mui/material'
import AvatarAgent from './AvatarAgent'
import { affichageNomPrenom } from '../Utils/fonctions'
import { IAgent } from '../../lib/interface/agent'
import { useFetchContext } from '../../hook/UseFetchContext'
import { CLEAR_AGENT, GET_AGENT_SUCCESS } from '../../lib/typeKey'
import useHandleChangeAgent from '../../hook/UseHandleChangeAgent'
import { Theme } from '@mui/material/styles'

const styles: Record<string, SxProps<Theme>> = {
  avatar: { color: 'primary.main', backgroundColor: 'secondary.main' },
  gras: { fontWeight: 'bold' },
  hover: {
    '&:focus, &:hover': {
      backgroundColor: 'hover.cadre',
      '& p': {
        textDecoration: 'underline',
        textDecorationThickness: '2px',
        color: '#0802A4'
      }
    }
  },
  selectedHover: {
    backgroundColor: 'selected.cadre',
    color: 'selected.texte',
    '&:focus, &:hover': { backgroundColor: 'selected.cadre' }
  }
}

export default function ListeAgent() {
  const { state, dispatch } = useFetchContext()
  const agents = state.agentState.agents
  const agentsTotal = state.agentTotalState.agentsTotal
  const agentSelected = state.agentState.agentSelected
  const noeudSelected = state.noeudSelectedState.noeudSelected
  const noeuds = state.dimensionState.noeuds
  const handleChangeAgent = useHandleChangeAgent()

  useEffect(() => {
    let newList: string[] = []
    const noeudComplet = noeuds.find((noeud: INoeudDimension) => noeud.identifiantNoeudDimension === noeudSelected)

    if (noeudComplet) {
      newList = noeudComplet.valeurs
      if (newList.length > 0) {
        dispatch({
          type: GET_AGENT_SUCCESS,
          payload: agentsTotal.filter((agent: IAgent) => newList.includes(agent.affectation.unite))
        })
      } else {
        dispatch({ type: CLEAR_AGENT })
      }
    }
  }, [agentsTotal, noeudSelected, noeuds])

  return (
    <div>
      {agents.length > 0 ? (
        <List
          dense
          component="div"
        >
          {agents.map((agent: IAgent) => {
            const labelId = `${agent.identifiantsAgent.matricule}`
            const responsable = agent.affectation.estResponsable ? ' (responsable)' : ''
            const select = agentSelected
              ? agentSelected.identifiantsAgent.matricule === agent.identifiantsAgent.matricule
              : false
            return (
              <ListItemButton
                key={labelId}
                onClick={() => handleChangeAgent(agent)}
                autoFocus={select}
                sx={select ? styles.selectedHover : styles.hover}
                data-cy={`agent-${agent.identifiantsAgent.idep}`}
              >
                <ListItemAvatar>
                  <AvatarAgent
                    agent={agent}
                    sx={styles.avatar}
                  />
                </ListItemAvatar>
                <ListItemText
                  id={labelId}
                  primary={
                    <Typography sx={select ? styles.gras : styles.hoverText}>
                      {affichageNomPrenom(agent.etatCivil.nomUsage, agent.etatCivil.prenomUsuel) + responsable}
                    </Typography>
                  }
                  data-cy={`agent-${agent.identifiantsAgent.idep}`}
                />
              </ListItemButton>
            )
          })}
        </List>
      ) : (
        <Typography align="center">Aucun agent affecté sur l'unité sélectionnée</Typography>
      )}
    </div>
  )
}
